import React from 'react';
import { Wifi, WifiOff } from 'lucide-react';

const MQTTStatus = ({ connected, error }) => {
  return (
    <div className="mqtt-status">
      {connected ? (
        <span className="mqtt-connected">
          <Wifi size={16} />
        </span>
      ) : (
        <span className="mqtt-disconnected">
          <WifiOff size={16} />
          {error && <span className="mqtt-error"> ({error})</span>}
        </span>
      )}
    </div>
  );
};

export default MQTTStatus;